import {useEffect, useRef, useState} from "react";
import callPeerRemoteModule from "../../../core/utils/callPeerRemoteModule";
import {shallowEqual, useSelector} from "react-redux";



const useScrollHeaderOpacity = () => {
  const { connectMode } = useSelector(state => ({
    connectMode: state.theme.connectMode,
  }),shallowEqual);

  const containerRef = useRef();
  const bodyRef = useRef();
  const innerRef = useRef();
  const offsetTopList = useSelector(state => state.summary.offsetTopList);

  const [isHeaderOpaque, setIsHeaderOpaque] = useState(false);

  let timer;
  const scrollHandle = async () => {
    const peer = await callPeerRemoteModule(connectMode);

    if (timer) {
      clearTimeout(timer);
    }

    if (bodyRef.current.scrollTop >= innerRef.current.offsetTop) {
      setIsHeaderOpaque(true);
    } else {
      setIsHeaderOpaque(false);
    }

    if (!peer) {
      return;
    }

    timer = setTimeout(() => {
      const navContainerIndex = offsetTopList.findIndex(item => item >= bodyRef.current.scrollTop);

      peer.conn.sendData("dispatch", {
        action: "summaryAction",
        func: "setRemoteScrollData",
        payload: {
          offsetTopList: offsetTopList,
          currentScrollTop: bodyRef.current.scrollTop,
          currentScrollIndex: navContainerIndex
        }
      });
    }, 300);
  }


  useEffect(() => {
    bodyRef?.current?.addEventListener("scroll", scrollHandle);
    return () => {
      bodyRef?.current?.removeEventListener("scroll", scrollHandle);
    }
  }, [offsetTopList]);


  useEffect(() => {
    containerRef.current &&
    containerRef.current.addEventListener("wheel", (e) => {
      e.stopPropagation();
    }, { passive: false })
  }, []);



  return { containerRef, bodyRef, innerRef, isHeaderOpaque }
}
export default useScrollHeaderOpacity;
